import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './styles/index.css';
import './styles/designPreview.css';
import './i18n/config'; // Initiera i18n

// Filtrera bort browser extension-fel (t.ex. feature_collector, "message channel closed")
function isExtensionWarning(message: string | undefined): boolean {
  if (!message) return false;
  const m = message.toLowerCase();
  return (
    m.includes('message channel closed') ||
    m.includes('asynchronous response') ||
    m.includes('listener indicated an asynchronous response') ||
    m.includes('feature_collector') ||
    m.includes('deprecated parameters') ||
    m.includes('initialization function') ||
    m.includes('pass a single object instead')
  );
}

window.addEventListener('error', (event) => {
  if (isExtensionWarning(event.message)) {
    event.preventDefault();
    return false;
  }
});

window.addEventListener('unhandledrejection', (event) => {
  const msg = event.reason?.message ?? event.reason?.toString?.() ?? '';
  if (isExtensionWarning(msg)) {
    event.preventDefault();
    return false;
  }
});

// Dämpa varningar från tillägg (t.ex. feature_collector.js deprecated parameters)
const _warn = console.warn;
const _error = console.error;
console.warn = function (...args: unknown[]) {
  const msg = typeof args[0] === 'string' ? args[0] : String(args[0]);
  if (isExtensionWarning(msg)) return;
  _warn.apply(console, args);
};
console.error = function (...args: unknown[]) {
  const msg = typeof args[0] === 'string' ? args[0] : String(args[0]);
  if (isExtensionWarning(msg)) return;
  _error.apply(console, args);
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
